module.exports = __webpack_public_path__ + "img/Character_Baizhu_Thumb.f95c8861.png";